module.exports = __webpack_public_path__ + "img/icon-dispatch.0e11c773.png";